"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPromise = (value) => {
    return (value && typeof value.then === 'function' && typeof value.catch === 'function');
};
exports.wait = (ms = 0) => new Promise(resolve => setTimeout(resolve, ms));
//# sourceMappingURL=index.js.map